import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingComponent = () => {
  return (
    <div className="flex-center">
      <CircularProgress />
    </div>
  );
};

export default LoadingComponent;
